import { render } from "./GuestCard.vue?vue&type=template&id=2b7e7faf&scoped=true&ts=true"
import script from "./GuestCard.vue?vue&type=script&lang=ts"
export * from "./GuestCard.vue?vue&type=script&lang=ts"

import "./GuestCard.vue?vue&type=style&index=0&id=2b7e7faf&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7e7faf"]])

export default __exports__